import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchPatientCredits, EMPTY_CREDITS } from "../../services/patientCredits";



export const getPatientCredits = createAsyncThunk(
  "credits/getPatientCredits",
  async (_, { rejectWithValue, getState }) => {
    const user = getState()?.authentication?.userAuth;
    const token = user?.obj?.token || user?.token;
    try {
      return await fetchPatientCredits(token);
    } catch (error) {
      return rejectWithValue(error?.response?.data ?? { message: error?.message });
    }
  }
);

const creditsSlice = createSlice({
  name: "credits",
  initialState: {
    ...EMPTY_CREDITS,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getPatientCredits.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getPatientCredits.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      Object.assign(state, action.payload ?? EMPTY_CREDITS);
    });
    builder.addCase(getPatientCredits.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.message || "Failed to load appointment credits.";
    });
  },
});

export default creditsSlice.reducer;
